export function getLayerDomId(layerId: string): string {
  return `TDL-${layerId}`;
}
